import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Maintenance } from '../Maintenance/Maintenance.jsx';
import ReactGA from 'react-ga';
let meta = '', useragent = navigator.userAgent;

export class TopicsComponent extends Component {
    displayName = TopicsComponent.name
    constructor(props) {
        super(props);
        this.state = { pagedesc: '', IsError: false }
        this.state = {
            practiceAreasList: []
        }
    }
    getAllData() {
        var self = this;
        appService.getAll('Product/GetAllPracticeAreas').then(function (data) {
            if (data == "Error found") {
                //  window.location = "/Maintenance";
                self.setState({ IsError: true });
            }
            else {
               
                self.setState({ practiceAreasList: data });
            }
        });
    };
    componentDidMount() {
        var self = this;
        self.getAllData();

        appService.getAll('AppData/GetAppData?fieldName=Topic page Desc').then(function (data) {
            if (data.value !== null) {
                if (data == "Error found") {
                    // window.location = "/Maintenance";
                    self.setState({ IsError: true });
                }
                else {
                    self.setState({ pagedesc: data.value });
                }
            }
            // console.log(self.state.pagedesc);
        });

        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '' + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'User= ' + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        var msg = {
            ArticleTitle: window['NTPT_PGEXTRA']
        }
        var Logurl = 'Product/LogData';
        appService.submit(Logurl, msg).then(function (data) {

        });

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Practice areas");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }

    //Redirect Click Event 
    topicDescriptionRedirect(e) {
        e.preventDefault();
        //alert(e.id);

    }

    render() {
        if (this.state.IsError != true) {
            meta = {
                title: "Kluwer Law Online - Practice areas",
                description: "Browse our practice areas to discover which journals and manuals we offer in your area of legal practice or on important legal subject-matters",
                canonical: window.location.href,
                meta: {
                    charset: "utf-8",
                    name: {
                        title: "Practice Areas | Kluwer Law Online",
                        description: "Browse our practice areas to discover which journals and manuals we offer in your area of legal practice or on important legal subject-matters"
                    }
                }
            }
        }
        return (
            this.state.IsError != true ?
                <DocumentMeta {...meta}>
                    <div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-9">
                                    <h1><p className="TitlePadding Title">Practice areas</p></h1>
                                    <div className="colPadding IntroText" dangerouslySetInnerHTML={{ __html: this.state.pagedesc }}></div>
                                    <br></br>
                                </div>
                            </div>
                            {
                                this.state.practiceAreasList.map((item, key) =>

                                    <div className="row" key={item.topic}>

                                        <span className="TitlePadding">
                                            <img alt="" src="/../../images/green-arrow.png" />
                                            <Link className="LinkClass" id={item.id} style={{ marginLeft: '5px' }} to={"/PracticeArea?Id=" + item.id + "&name=" + item.topic.replace(/ /g, "+")}>
                                                {item.topic}
                                            </Link>
                                            &nbsp; <span style={{ color: '#757575' }}>({(item.productCount)})</span>
                                        </span>
                                    </div>

                                )
                            }
                            <div className="White">
                            </div>
                        </div >
                    </div>
                </DocumentMeta >
                :
                <Maintenance />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Topics/TopicsComponent.jsx